import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { themeColor } from '../../Theming';
import KindredLogo from '../Logos/KindredLogo';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: fit-content;
`;

const Text = styled.p`
  font-size: 0.875rem;
  margin-right: 5px;
  color: ${themeColor('veryDarkBlue')};
`;

const Paragraph = styled.p`
  text-align: center;
  line-height: 1.25rem;
  font-size: 0.875rem;
  color: ${themeColor('veryDarkBlue')};
  padding: 0 26px;
  margin-bottom: 17px;
`;

interface PoweredByKindredProps {
  hasInfo?: boolean;
}

const PoweredByKindred: React.FC<PoweredByKindredProps> = ({ hasInfo }) => {
  const [showInfo, setShowInfo] = useState(false);

  const { t } = useTranslation();
  return (
    <Container>
      <StyledFlex onClick={() => setShowInfo(!showInfo)}>
        <Text>{t('global.poweredBy')}</Text>
        <KindredLogo width={100} />
      </StyledFlex>
      {hasInfo && showInfo && <Paragraph>{t('global.kindredInfo')}</Paragraph>}
    </Container>
  );
};

export default PoweredByKindred;
